import React from 'react';

const Confirmation = ({ onReset }) => {
  return (
    <div className='card p-8 max-w-2xl mx-auto text-center'>
      <div className='flex justify-center mb-6'>
        <div className='w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center'>
          <svg className='w-8 h-8 text-white' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
          </svg>
        </div>
      </div>
      
      <h2 className='text-2xl font-semibold text-slate-800 mb-4'>Thank You!</h2>
      <p className='text-slate-600 mb-6 leading-relaxed'>
        Your message has been sent successfully. We appreciate you reaching out and will get back to you within 24 hours.
      </p>
      
      <div className='space-y-4'>
        <div className='p-4 bg-blue-50 border border-blue-200 rounded-lg'>
          <p className='text-sm text-blue-700 flex items-center justify-center gap-2'>
            <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 24 24'>
              <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/>
            </svg>
            We'll respond to your inquiry within 24 hours
          </p>
        </div>
        
        <div className='flex flex-col sm:flex-row gap-3 justify-center pt-4'>
          {onReset && (
            <button 
              onClick={onReset}
              className='btn-secondary inline-flex items-center gap-2'
            >
              Send Another Message
              <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4v16m8-8H4' />
              </svg>
            </button>
          )}
          
          <a 
            href='/' 
            className='btn-primary inline-flex items-center gap-2'
          >
            Back to Home
            <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;